//mui
import {Typography} from '@mui/material';
//constants
import {BODY2, NO_DATA_FOUND} from '@/utils/constants';
//styles
import {emptyTableDataStyle} from './EmptyTableData.styles';

const EmptyTableData = ({text}: {text?: string}) => {
	return (
		<Typography variant={BODY2} sx={emptyTableDataStyle.title}>
			{text || NO_DATA_FOUND}
		</Typography>
	);
};

export default EmptyTableData;
